import { render, staticRenderFns } from "./BusinessRegisteration.vue?vue&type=template&id=aaf4f94a&"
import script from "./BusinessRegisteration.vue?vue&type=script&lang=js&"
export * from "./BusinessRegisteration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports